export default __webpack_public_path__ + "static/media/PC_v1_image@3x.67c7786d.png";